import React from 'react'
import Image from 'next/image'

interface IProps {
  logo: string
  content: string
  avatar: string
  name: string
  position: string
  logoWidth: number
  logoHeight: number
}

const Testimonial = ({
  logo,
  logoHeight,
  logoWidth,
  content,
  avatar,
  name,
  position,
}: IProps) => (
  <div className='w-full border-1 border-gray-bg p-6 flex flex-col'>
    <div className='flex justify-center items-center p-10'>
      <Image
        src={logo}
        alt='Company Logo'
        className='w-72 h-20 object-contain'
        width={logoWidth}
        height={logoHeight}
        loading='lazy'
      />
    </div>
    <hr className='border-1 border-gray-bg my-6' />
    <p className=' font-thin text-md flex-grow'>{content}</p>
    <div className='flex mt-12 gap-8 items-center md:flex-col lg:flex-row'>
      <Image
        src={avatar}
        alt={name}
        width={128}
        height={128}
        className='w-24 rounded-full'
        loading='lazy'
      />
      <div>
        <h3 className='text-purple text-md font-semibold'>{name}</h3>
        <p className='text-purple text-base font-thin'>{position}</p>
      </div>
    </div>
  </div>
)

export default Testimonial
